
import useFeature from '@/mixins/useFeature'

export default function googleAutocomplete () {
  return {
    data () {
      return {
        autocompleteHandler: null,
        hasAutocompleteError: false
      }
    },
    mixins: [
      useFeature('googleAutocomplete')
    ],
    methods: {
      initiateAutocomplete (autocompleteCallback = () => {}, inputId = 'pac-container') {
        let key = 'AIzaSyCW5Q-IaJdZKJmF6QUW-0-83Kbh9Ou_-N4'
        if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_GOOGLE_API_KEY) {
          key = process.env.VUE_APP_GOOGLE_API_KEY
        }
        if (this.isEligibleForAutocomplete && typeof google === 'undefined') {
          window.mapsCallback = () => autocompleteCallback()
          const script = document.createElement('script')
          script.src = 'https://maps.googleapis.com/maps/api/js?key=' + key + '&libraries=places&language=de&region=DE&callback=mapsCallback'
          script.async = true

          document.body.appendChild(script)
        } else if (this.isEligibleForAutocomplete && typeof google !== 'undefined') {
          autocompleteCallback()
        }
      },
      setupAutocompleteHandler (targetInput, scrollListenerTarget = null) {
        const observeAutocompleteDropdown = (target) => {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'childList') {
                this.autocompleteHasNewResults()
              }
            })
          })

          observer.observe(target, { childList: true, subtree: true })
        }

        document.querySelectorAll('.pac-container').forEach(e => e.remove())
        this.autocompleteHandler = new google.maps.places.Autocomplete(targetInput, {
          componentRestrictions: { country: 'DE' },
          fields: ['address_components'],
          types: ['address']
        })
        this.autocompleteHandler.addListener('place_changed', this.performAutocomplete)

        const waitForPacContainer = () => {
          const observer = new MutationObserver((mutationsList, observer) => {
            const pacContainer = document.querySelector('.pac-container')
            if (pacContainer) {
              pacContainer.addEventListener('mousedown', this.onPacContainerClicked.bind(this))
              observeAutocompleteDropdown(pacContainer)
              observer.disconnect()
            }
          })

          observer.observe(document.body, { childList: true, subtree: true })
        }

        waitForPacContainer()

        if (scrollListenerTarget !== null) {
          scrollListenerTarget.addEventListener('scroll', function () {
            const newTop = targetInput.getBoundingClientRect().top + targetInput.offsetHeight
            const pacContainer = document.getElementsByClassName('pac-container')
            if (pacContainer.length > 0) {
              pacContainer[0].style.top = newTop + 'px'
            }
          })
        }
      },
      onPacContainerClicked (event) {
        // throw new Error('Overwrite onPacContainerClicked in component!')
      },
      autocompleteHasNewResults () {
        // throw new Error('Overwrite autocompleteHasNewResults in component!')
      },
      performAutocomplete () {
        throw new Error('Overwrite performAutocomplete in component!')
      }
    },
    computed: {
      isEligibleForAutocomplete () {
        let hasCorrectConsent = false
        if (this.googleAutocomplete && window.cookieNS && window.cookieNS.main && window.cookieNS.main.getCookie) {
          const optanonConsentCookie = window.cookieNS.main.getCookie('OptanonConsent')
          var parts = optanonConsentCookie.split('groups=').pop().split('&').shift().split(',')
          parts.forEach((entry) => {
            if (entry.replace('C000', '') === '4:1') {
              hasCorrectConsent = true
            }
          })
        }
        return this.googleAutocomplete && hasCorrectConsent
      }
    }
  }
}
